// extracted by mini-css-extract-plugin
export default {"item":"ConversationsList-modules__item__C3TK6"};